export default function Wordmark({ tone = "ink", className = "h-6 w-auto" }) {
  return (
    <img
      src={tone === "cream" ? "/images/logo-vivore-ivory.png" : "/images/logo-vivore-black.png"}
      alt="vivoré"
      draggable={false}
      className={`w-auto select-none ${className}`}
    />
  );
}

export function Monogram({ tone = "ink", className = "h-8 w-auto" }) {
  const src =
    tone === "cream"
      ? "/images/logo-vi-ivory.png"
      : tone === "lilac"
      ? "/images/logo-vi-lilac.png"
      : "/images/logo-vi-black.png";
  return (
    <img
      src={src}
      alt="vi"
      draggable={false}
      className={`w-auto select-none ${className}`}
    />
  );
}
